import React, { useState } from 'react';
import { colors, shadows } from '../features/employees/styles/personalakteStyles';

interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
  icon?: React.ReactNode;
}

export default function PrimaryButton({
  children,
  onClick,
  type = 'button',
  disabled = false,
  style,
  className,
  icon,
}: PrimaryButtonProps): React.JSX.Element {
  const [isHovered, setIsHovered] = useState(false);

  const baseStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '12px 24px',
    border: 'none',
    borderRadius: 9999,
    background: disabled
      ? '#9ca3af'
      : `linear-gradient(90deg, ${colors.navy} 0%, ${colors.navy} 30%, ${colors.magenta} 100%)`,
    color: 'white',
    fontSize: '14px',
    fontWeight: 600,
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'all 0.2s ease',
    boxShadow: disabled
      ? 'none'
      : isHovered
        ? '0 6px 20px rgba(14, 19, 51, 0.35)'
        : shadows.card,
    transform: isHovered && !disabled ? 'translateY(-1px)' : 'translateY(0)',
    ...style,
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={baseStyles}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {icon}
      {children}
    </button>
  );
}
